export default __webpack_public_path__ + "static/69-e3d21292dc5ef36e994495c6949e1f29.png";